// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xd17UK {
  display: flex;
  flex-direction: column;
  gap: 24px;
  height: 100%;
}

.sN9ciL {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 24px;
}

.iGX2wp {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
}

.iaUk4U {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-0-5);
}

.fQTyKp {
  font-family: var(--font-family-base);
  font-size: var(--type-title-md-font-size);
  font-weight: var(--type-title-md-font-weight);
  line-height: var(--type-title-md-line-height);
  color: var(--text-neutral-dark);
  margin: 0;
  text-align: left;
}

.Phelf3 {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-self: stretch;
}

.xwRCWe {
  display: flex;
  flex-direction: row;
  gap: 16px;
  padding: 16px;
  border-radius: 4px;
  background: var(--surface-neutral-light);
  cursor: pointer;
  transition: background-color 0.2s;
}

.xwRCWe:hover {
  background: var(--surface-neutral-light-hover);
}

.hLXxey {
  background: var(--surface-orange-light);
}

.KDJYgb {
  display: flex;
  align-items: flex-start;
  padding-top: 2px;
}

.Ll_Lj2 {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
}

.fEz2bP {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.rmucYP {
  font-family: var(--font-family-base);
  font-size: var(--type-label-lg-font-size);
  font-weight: var(--type-label-lg-semibold-font-weight);
  line-height: var(--type-label-lg-line-height);
  color: var(--text-neutral-dark);
  margin: 0;
}

.K6rVa9 {
  font-family: var(--font-family-base);
  font-size: var(--type-caption-font-size);
  font-weight: var(--type-caption-regular-font-weight);
  line-height: var(--type-caption-line-height);
  color: var(--text-neutral-dark);
  margin: 0;
}

.nmOKIN {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.HsUzFN {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
}

.VjcVQo {
  font-size: 10px;
  width: 10px;
  height: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.BpgYV6 {
  font-family: var(--font-family-base);
  font-size: var(--type-label-xs-font-size);
  font-weight: var(--type-label-xs-regular-font-weight);
  line-height: var(--type-label-xs-line-height);
  color: var(--text-neutral-dark);
}

.e3ZPxU {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 8px;
}

.DBQrCu {
  width: 100%;
  height: 1px;
  background: var(--border-neutral-light);
}

.CQ17m7 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
}

.szEzUx {
  font-family: var(--font-family-base);
  font-size: var(--type-label-xs-font-size);
  font-weight: var(--type-label-xs-regular-font-weight);
  line-height: var(--type-label-xs-line-height);
  color: var(--text-neutral-medium);
  margin: 0;
}

.BieHHM {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}

.d0TlM4 {
  font-family: var(--font-family-base);
  font-size: var(--type-label-xs-font-size);
  font-weight: var(--type-label-xs-semibold-font-weight);
  line-height: var(--type-label-xs-line-height);
  color: var(--text-neutral-dark);
}

.q_B70W {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  font-size: 16px;
}

@media (max-width: 768px) {
  .xd17UK {
    gap: 16px;
  }

  .sN9ciL {
    margin-bottom: 16px;
  }

  .iaUk4U {
    gap: var(--spacing-0-25);
  }

  .fQTyKp {
    font-size: 16px;
  }

  .xwRCWe {
    padding: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/HiringPage/components/HiringProductFamily/HiringProductFamily.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;EACzC,6CAA6C;EAC7C,6CAA6C;EAC7C,+BAA+B;EAC/B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,OAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;EACzC,sDAAsD;EACtD,6CAA6C;EAC7C,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,oDAAoD;EACpD,4CAA4C;EAC5C,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;EACzC,qDAAqD;EACrD,6CAA6C;EAC7C,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;EACzC,qDAAqD;EACrD,6CAA6C;EAC7C,iCAAiC;EACjC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;EACzC,sDAAsD;EACtD,6CAA6C;EAC7C,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".stepContent {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  height: 100%;\n}\n\n.cardIllustration {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.cardImage {\n  max-width: 100%;\n  height: auto;\n  border-radius: 8px;\n}\n\n.explanation {\n  align-self: stretch;\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-0-5);\n}\n\n.title {\n  font-family: var(--font-family-base);\n  font-size: var(--type-title-md-font-size);\n  font-weight: var(--type-title-md-font-weight);\n  line-height: var(--type-title-md-line-height);\n  color: var(--text-neutral-dark);\n  margin: 0;\n  text-align: left;\n}\n\n.optionsList {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  align-self: stretch;\n}\n\n.optionCard {\n  display: flex;\n  flex-direction: row;\n  gap: 16px;\n  padding: 16px;\n  border-radius: 4px;\n  background: var(--surface-neutral-light);\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.optionCard:hover {\n  background: var(--surface-neutral-light-hover);\n}\n\n.optionCardSelected {\n  background: var(--surface-orange-light);\n}\n\n.checkboxContainer {\n  display: flex;\n  align-items: flex-start;\n  padding-top: 2px;\n}\n\n.optionContent {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  flex: 1;\n}\n\n.optionHeader {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.optionTitle {\n  font-family: var(--font-family-base);\n  font-size: var(--type-label-lg-font-size);\n  font-weight: var(--type-label-lg-semibold-font-weight);\n  line-height: var(--type-label-lg-line-height);\n  color: var(--text-neutral-dark);\n  margin: 0;\n}\n\n.optionDescription {\n  font-family: var(--font-family-base);\n  font-size: var(--type-caption-font-size);\n  font-weight: var(--type-caption-regular-font-weight);\n  line-height: var(--type-caption-line-height);\n  color: var(--text-neutral-dark);\n  margin: 0;\n}\n\n.optionTypes {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.optionType {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 4px;\n}\n\n.optionTypeIcon {\n  font-size: 10px;\n  width: 10px;\n  height: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.optionTypeLabel {\n  font-family: var(--font-family-base);\n  font-size: var(--type-label-xs-font-size);\n  font-weight: var(--type-label-xs-regular-font-weight);\n  line-height: var(--type-label-xs-line-height);\n  color: var(--text-neutral-dark);\n}\n\n.patInfo {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 8px;\n}\n\n.divider {\n  width: 100%;\n  height: 1px;\n  background: var(--border-neutral-light);\n}\n\n.patNumberSection {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 4px;\n}\n\n.patNumberLabel {\n  font-family: var(--font-family-base);\n  font-size: var(--type-label-xs-font-size);\n  font-weight: var(--type-label-xs-regular-font-weight);\n  line-height: var(--type-label-xs-line-height);\n  color: var(--text-neutral-medium);\n  margin: 0;\n}\n\n.patNumberContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n}\n\n.patNumber {\n  font-family: var(--font-family-base);\n  font-size: var(--type-label-xs-font-size);\n  font-weight: var(--type-label-xs-semibold-font-weight);\n  line-height: var(--type-label-xs-line-height);\n  color: var(--text-neutral-dark);\n}\n\n.copyButton {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  font-size: 16px;\n}\n\n@media (max-width: 768px) {\n  .stepContent {\n    gap: 16px;\n  }\n\n  .cardIllustration {\n    margin-bottom: 16px;\n  }\n\n  .explanation {\n    gap: var(--spacing-0-25);\n  }\n\n  .title {\n    font-size: 16px;\n  }\n\n  .optionCard {\n    padding: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stepContent": `xd17UK`,
	"cardIllustration": `sN9ciL`,
	"cardImage": `iGX2wp`,
	"explanation": `iaUk4U`,
	"title": `fQTyKp`,
	"optionsList": `Phelf3`,
	"optionCard": `xwRCWe`,
	"optionCardSelected": `hLXxey`,
	"checkboxContainer": `KDJYgb`,
	"optionContent": `Ll_Lj2`,
	"optionHeader": `fEz2bP`,
	"optionTitle": `rmucYP`,
	"optionDescription": `K6rVa9`,
	"optionTypes": `nmOKIN`,
	"optionType": `HsUzFN`,
	"optionTypeIcon": `VjcVQo`,
	"optionTypeLabel": `BpgYV6`,
	"patInfo": `e3ZPxU`,
	"divider": `DBQrCu`,
	"patNumberSection": `CQ17m7`,
	"patNumberLabel": `szEzUx`,
	"patNumberContainer": `BieHHM`,
	"patNumber": `d0TlM4`,
	"copyButton": `q_B70W`
};
module.exports = ___CSS_LOADER_EXPORT___;
